import React from 'react';
import ResponsiveImage from 'components/base/responsiveImage/ResponsiveImage';
import type { ArticleAttribution as ArticleAttributionType } from 'types';
import { hasArticleAttribution } from 'utils/articleAttributionTransform';

interface ArticleAttributionProps {
  attribution: ArticleAttributionType;
  className?: string;
}

export function ArticleAttribution({
  attribution,
}: ArticleAttributionProps): React.JSX.Element | null {
  if (!hasArticleAttribution(attribution)) {
    return null;
  }

  return (
    <div className="articleAttribution">
      {attribution.avatar && (
        <div className="articleAttribution__avatar">
          <ResponsiveImage
            images={{ image: attribution.avatar }}
            alt={attribution.avatar.alt || attribution.author || ''}
          />
        </div>
      )}
      {attribution.author && (
        <span className="articleAttribution__author">{attribution.author}</span>
      )}
    </div>
  );
}
